import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/Discount_App_logo.png";

function WebsiteHomePage() {
  return (
    <div id="home" className="container py-5 text-center">
      <div className="mb-4">
        <img src={logo} alt="Discount App Logo" style={{ maxHeight: "120px", objectFit: "contain" }} />
      </div>
      <h1>Welcome! Home page of Discount App</h1>
      <Link className="btn btn-outline-success mt-3" to={"/admin/login"}>
        Go to admin
      </Link>
      <Link className="btn btn-outline-success mt-3 mx-2" to={"/business"}>
        Go to Business
      </Link>
    </div>
  );
}

export default WebsiteHomePage;
